<template>
  <WdsRadioGroup
    row
    name="ratetype"
    :checked="modelValue"
    :options="rateTypes"
    @update:checked="$emit('update:modelValue', $event)"
  />
</template>

<script>
import { WdsRadioGroup } from '@worksome/wds-components'
import { RateType } from '@/enums'

export default {
  components: {
    WdsRadioGroup,
  },
  props: {
    modelValue: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    rateTypes() {
      return [
        {
          value: RateType.HOURLY,
          label: this.$t('Hourly'),
        },
        {
          value: RateType.DAILY,
          label: this.$t('Daily'),
        },
        {
          value: RateType.WEEKLY,
          label: this.$t('Weekly'),
        },
        {
          value: RateType.MONTHLY,
          label: this.$t('Monthly'),
        },
        {
          value: RateType.FIXED,
          label: this.$t('Fixed'),
        },
      ]
    },
  },
}
</script>
